<ng-container *transloco="let t">
    <h1>{{ t('hot-auction-list.title') }}</h1>

    <td-hot-auction-table></td-hot-auction-table>
</ng-container>
